
export const guestModel = {

  name: null,
  uid: null,
  surname: null,
  email: null,
  accompanying_persons: 0,
  note: null,
  field0: null,
  field1: null,
  field2: null,
  field3: null,
  field4: null,
  field5: null

}
